// This array contains commonly used FontAwesome5 icons available in @expo/vector-icons

export const options = [
  // Basic Icons
  { value: 'home', label: 'Home' },
  { value: 'user', label: 'User' },
  { value: 'users', label: 'Users' },
  { value: 'heart', label: 'Heart' },
  { value: 'star', label: 'Star' },
  { value: 'search', label: 'Search' },
  { value: 'bars', label: 'Bars' },
  { value: 'times', label: 'Close' },
  { value: 'plus', label: 'Plus' },
  { value: 'minus', label: 'Minus' },
  { value: 'edit', label: 'Edit' },
  { value: 'trash', label: 'Trash' },
  { value: 'save', label: 'Save' },
  { value: 'download', label: 'Download' },
  { value: 'upload', label: 'Upload' },
  { value: 'cog', label: 'Settings' },
  { value: 'lock', label: 'Lock' },
  { value: 'unlock', label: 'Unlock' },
  { value: 'eye', label: 'Eye' },
  { value: 'eye-slash', label: 'Eye Slash' },
  { value: 'check', label: 'Check' },
  { value: 'check-circle', label: 'Check Circle' },
  { value: 'times-circle', label: 'Times Circle' },
  { value: 'exclamation-triangle', label: 'Warning' },
  { value: 'info-circle', label: 'Info Circle' },
  { value: 'question-circle', label: 'Question Circle' },

  // Navigation & Arrows
  { value: 'arrow-left', label: 'Arrow Left' },
  { value: 'arrow-right', label: 'Arrow Right' },
  { value: 'arrow-up', label: 'Arrow Up' },
  { value: 'arrow-down', label: 'Arrow Down' },
  { value: 'chevron-left', label: 'Chevron Left' },
  { value: 'chevron-right', label: 'Chevron Right' },
  { value: 'chevron-up', label: 'Chevron Up' },
  { value: 'chevron-down', label: 'Chevron Down' },
  { value: 'angle-left', label: 'Angle Left' },
  { value: 'angle-right', label: 'Angle Right' },
  { value: 'angle-up', label: 'Angle Up' },
  { value: 'angle-down', label: 'Angle Down' },
  { value: 'caret-left', label: 'Caret Left' },
  { value: 'caret-right', label: 'Caret Right' },
  { value: 'caret-up', label: 'Caret Up' },
  { value: 'caret-down', label: 'Caret Down' },

  // Communication
  { value: 'phone', label: 'Phone' },
  { value: 'envelope', label: 'Email' },
  { value: 'comment', label: 'Comment' },
  { value: 'comments', label: 'Comments' },
  { value: 'paper-plane', label: 'Send' },
  { value: 'reply', label: 'Reply' },
  { value: 'share', label: 'Share' },
  { value: 'share-alt', label: 'Share Alt' },

  // Social Media
  { value: 'facebook', label: 'Facebook' },
  { value: 'twitter', label: 'Twitter' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'github', label: 'GitHub' },
  { value: 'google', label: 'Google' },
  { value: 'apple', label: 'Apple' },
  { value: 'microsoft', label: 'Microsoft' },
  { value: 'amazon', label: 'Amazon' },
  { value: 'paypal', label: 'PayPal' },
  { value: 'stripe', label: 'Stripe' },

  // Media & Entertainment
  { value: 'play', label: 'Play' },
  { value: 'pause', label: 'Pause' },
  { value: 'stop', label: 'Stop' },
  { value: 'forward', label: 'Forward' },
  { value: 'backward', label: 'Backward' },
  { value: 'volume-up', label: 'Volume Up' },
  { value: 'volume-down', label: 'Volume Down' },
  { value: 'volume-mute', label: 'Volume Mute' },
  { value: 'music', label: 'Music' },
  { value: 'video', label: 'Video' },
  { value: 'camera', label: 'Camera' },
  { value: 'image', label: 'Image' },
  { value: 'film', label: 'Film' },
  { value: 'microphone', label: 'Microphone' },
  { value: 'microphone-slash', label: 'Microphone Slash' },

  // Time & Calendar
  { value: 'clock', label: 'Clock' },
  { value: 'calendar', label: 'Calendar' },
  { value: 'calendar-alt', label: 'Calendar Alt' },
  { value: 'calendar-check', label: 'Calendar Check' },
  { value: 'calendar-plus', label: 'Calendar Plus' },
  { value: 'calendar-minus', label: 'Calendar Minus' },
  { value: 'calendar-times', label: 'Calendar Times' },

  // Location & Travel
  { value: 'map-marker-alt', label: 'Map Marker' },
  { value: 'map', label: 'Map' },
  { value: 'globe', label: 'Globe' },
  { value: 'plane', label: 'Plane' },
  { value: 'car', label: 'Car' },
  { value: 'bus', label: 'Bus' },
  { value: 'train', label: 'Train' },
  { value: 'bicycle', label: 'Bicycle' },
  { value: 'walking', label: 'Walking' },
  { value: 'running', label: 'Running' },

  // Shopping & Money
  { value: 'shopping-cart', label: 'Shopping Cart' },
  { value: 'shopping-bag', label: 'Shopping Bag' },
  { value: 'credit-card', label: 'Credit Card' },
  { value: 'money-bill', label: 'Money Bill' },
  { value: 'dollar-sign', label: 'Dollar Sign' },
  { value: 'euro-sign', label: 'Euro Sign' },
  { value: 'pound-sign', label: 'Pound Sign' },
  { value: 'yen-sign', label: 'Yen Sign' },
  { value: 'bitcoin', label: 'Bitcoin' },
  { value: 'ethereum', label: 'Ethereum' },

  // Technology & Devices
  { value: 'laptop', label: 'Laptop' },
  { value: 'desktop', label: 'Desktop' },
  { value: 'tablet-alt', label: 'Tablet' },
  { value: 'mobile-alt', label: 'Mobile' },
  { value: 'wifi', label: 'WiFi' },
  { value: 'bluetooth', label: 'Bluetooth' },
  { value: 'usb', label: 'USB' },
  { value: 'battery-full', label: 'Battery Full' },
  { value: 'battery-half', label: 'Battery Half' },
  { value: 'battery-empty', label: 'Battery Empty' },
  { value: 'plug', label: 'Plug' },
  { value: 'power-off', label: 'Power Off' },

  // Weather
  { value: 'sun', label: 'Sun' },
  { value: 'moon', label: 'Moon' },
  { value: 'cloud', label: 'Cloud' },
  { value: 'cloud-rain', label: 'Cloud Rain' },
  { value: 'cloud-sun', label: 'Cloud Sun' },
  { value: 'cloud-moon', label: 'Cloud Moon' },
  { value: 'snowflake', label: 'Snowflake' },
  { value: 'bolt', label: 'Lightning' },
  { value: 'umbrella', label: 'Umbrella' },

  // Health & Medical
  { value: 'heartbeat', label: 'Heartbeat' },
  { value: 'stethoscope', label: 'Stethoscope' },
  { value: 'pills', label: 'Pills' },
  { value: 'syringe', label: 'Syringe' },
  { value: 'band-aid', label: 'Band Aid' },
  { value: 'hospital', label: 'Hospital' },
  { value: 'ambulance', label: 'Ambulance' },
  { value: 'user-md', label: 'Doctor' },
  { value: 'tooth', label: 'Tooth' },

  // Food & Dining
  { value: 'utensils', label: 'Utensils' },
  { value: 'coffee', label: 'Coffee' },
  { value: 'pizza-slice', label: 'Pizza Slice' },
  { value: 'hamburger', label: 'Hamburger' },
  { value: 'ice-cream', label: 'Ice Cream' },
  { value: 'wine-glass', label: 'Wine Glass' },
  { value: 'beer', label: 'Beer' },
  { value: 'cocktail', label: 'Cocktail' },

  // Sports & Activities
  { value: 'football-ball', label: 'Football' },
  { value: 'basketball-ball', label: 'Basketball' },
  { value: 'baseball-ball', label: 'Baseball' },
  { value: 'futbol', label: 'Soccer Ball' },
  { value: 'golf-ball', label: 'Golf Ball' },
  { value: 'swimmer', label: 'Swimmer' },
  { value: 'dumbbell', label: 'Dumbbell' },
  { value: 'biking', label: 'Biking' },

  // Education & Learning
  { value: 'graduation-cap', label: 'Graduation Cap' },
  { value: 'book', label: 'Book' },
  { value: 'book-open', label: 'Book Open' },
  { value: 'pencil-alt', label: 'Pencil' },
  { value: 'pen', label: 'Pen' },
  { value: 'highlighter', label: 'Highlighter' },
  { value: 'eraser', label: 'Eraser' },
  { value: 'calculator', label: 'Calculator' },
  { value: 'ruler', label: 'Ruler' },
  { value: 'compass', label: 'Compass' },

  // Business & Office
  { value: 'briefcase', label: 'Briefcase' },
  { value: 'building', label: 'Building' },
  { value: 'chart-line', label: 'Chart Line' },
  { value: 'chart-bar', label: 'Chart Bar' },
  { value: 'chart-pie', label: 'Chart Pie' },
  { value: 'chart-area', label: 'Chart Area' },
  { value: 'handshake', label: 'Handshake' },
  { value: 'bullhorn', label: 'Bullhorn' },
  { value: 'newspaper', label: 'Newspaper' },

  // Tools & Utilities
  { value: 'hammer', label: 'Hammer' },
  { value: 'screwdriver', label: 'Screwdriver' },
  { value: 'wrench', label: 'Wrench' },
  { value: 'toolbox', label: 'Toolbox' },
  { value: 'key', label: 'Key' },
  { value: 'lock', label: 'Lock' },
  { value: 'unlock', label: 'Unlock' },
  { value: 'shield-alt', label: 'Shield' },
  { value: 'fire', label: 'Fire' },
  { value: 'water', label: 'Water' },

  // Miscellaneous
  { value: 'gift', label: 'Gift' },
  { value: 'birthday-cake', label: 'Birthday Cake' },
  { value: 'flag', label: 'Flag' },
  { value: 'trophy', label: 'Trophy' },
  { value: 'medal', label: 'Medal' },
  { value: 'award', label: 'Award' },
  { value: 'gem', label: 'Gem' },
  { value: 'crown', label: 'Crown' },
  { value: 'magic', label: 'Magic' },
  { value: 'rainbow', label: 'Rainbow' },
  { value: 'leaf', label: 'Leaf' },
  { value: 'tree', label: 'Tree' },
  { value: 'seedling', label: 'Seedling' },
  { value: 'recycle', label: 'Recycle' },
  { value: 'leaf', label: 'Leaf' },
  { value: 'bug', label: 'Bug' },
  { value: 'spider', label: 'Spider' },
  { value: 'cat', label: 'Cat' },
  { value: 'dog', label: 'Dog' },
  { value: 'fish', label: 'Fish' },
  { value: 'horse', label: 'Horse' },
  { value: 'paw', label: 'Paw' },
];
